import { createContext, useContext, useState, ReactNode, useEffect, useMemo } from 'react';
import { getDeviceBuildVersion, getSafeAreaTopHeight } from '../../utils';

interface MyContextType {
    topHeight: string;
    currentDeviceBuildVersion: boolean;
    myReservationHistoryTabKey: number;
    setMyReservationHistoryTabKey: React.Dispatch<React.SetStateAction<number>>;
    feedPlaceholder: string;
    communityTabKey: number;
    setCommunityTabKey: React.Dispatch<React.SetStateAction<number>>;
    deviceBuildVersion: string;
    isGnbFooterHidden: boolean;
    setIsGnbFooterHidden: React.Dispatch<React.SetStateAction<boolean>>
}

const MyContext = createContext<MyContextType | undefined>(undefined);
const feedPlaceholderList = [
    "오늘 있었던 건강한 순간을 기록해보세요.",
    "지금 머릿속에 떠오르는 편안한 이야기를 나눠보세요.",
    "자유롭게 당신의 이야기를 들려주세요.",
    "지금 나의 몸과 마음은 어떤가요?",
    "최근 나를 건강하게 만들어준 건 무엇인가요?",
    "요즘 발견한 나만의 웰니스 루틴은?"
]
const randomFeedPlaceholder = feedPlaceholderList[Math.floor(Math.random() * feedPlaceholderList.length)]
export const MyContextProvider = ({ children }: { children: ReactNode }) => {
    const [topHeight, setTopHeight] = useState<string>('0');
    const [currentDeviceBuildVersion, setCurrentDeviceBuildVersion] = useState<boolean>(false);
    const [myReservationHistoryTabKey, setMyReservationHistoryTabKey] = useState<number>(0);
    const [communityTabKey, setCommunityTabKey] = useState<number>(0);
    const [feedPlaceholder, setFeedPlaceholder] = useState<string>(randomFeedPlaceholder)
    const [deviceBuildVersion, setDeviceBuildVersion] = useState<string>('');
    const [isGnbFooterHidden, setIsGnbFooterHidden] = useState<boolean>(false)

    const value = {
        topHeight,
        currentDeviceBuildVersion,
        myReservationHistoryTabKey,
        setMyReservationHistoryTabKey,
        feedPlaceholder,
        communityTabKey,
        setCommunityTabKey,
        deviceBuildVersion,
        isGnbFooterHidden,
        setIsGnbFooterHidden,
    };

    useEffect(() => {
        getSafeAreaTopHeight(setTopHeight, setCurrentDeviceBuildVersion, setDeviceBuildVersion)
    }, [])

    return (
        <MyContext.Provider value={value}>
            {children}
        </MyContext.Provider>
    );
};

export const useMyContext = () => {
    const context = useContext(MyContext);
    if (!context) {
        throw new Error('useMyContext must be used within a MyContextProvider');
    }
    return context;
};